import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";
import FilterInTable from "../../../../Manage/FilterInTable";
import styles from "./Active.module.scss";
import PaginationComponent from "../../../../Manage/PaginationComponent";

const Active = () => {
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState([]);

  const data = [
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
  ];

  const columns = [
    {
      name: "Activate",
      cell: () => (
        <label className={styles.switch}>
          <input type="checkbox" />
          <span className={`${styles.slider} ${styles.round}`}></span>
        </label>
      ),
    },
    {
      name: "Campaign name",
      selector: (row) => row.name,
      minWidth: "160px",
    },
    {
      name: "Start date",
      selector: (row) => row.startDate,
      minWidth: "120px",
    },
    {
      name: "End date",
      selector: (row) => row.endDate,
      minWidth: "120px",
    },
    {
      name: "Last Update",
      selector: (row) => row.lastUpdate,
      minWidth: "140px",
    },
    {
      name: "Status",
      selector: (row) => {
        let color = "";
        switch (row.status) {
          case "Active":
            color = "#41B8E4";
            break;
          case "Deactivated":
            color = "#EC7426";
            break;
          case "Ended":
            color = "#EC7426";
            break;

          default:
            break;
        }
        return <span style={{ color }}>{row.status}</span>;
      },
      minWidth: "120px",
    },
    {
      name: "Action",
      cell: () => <span className="cursor-pointer">Edit/Delete</span>,
      minWidth: "120px",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
        div: {
          whiteSpace: "normal",
          overflow: "visible",
        },
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
        div: {
          whiteSpace: "normal !important",
          overflow: "visible !important",
        },
      },
    },
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentItems(data.slice(startIndex, endIndex));
  };

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    handlePageChange(1);
  };

  useEffect(() => {
    handlePageChange(currentPage);
  }, [currentPage, itemsPerPage]);

  return (
    <section>
      <div className={styles["totalCampaignBtnsRow"]}>
        <span className={styles["total-campaigns"]}>Total Campaign: 30</span>
        <div className={styles["dropdown-btns"]}>
          <div className="text-center">
            <div className={styles["button"]}>Print</div>
          </div>
          <div className="text-center">
            <div className={styles["button"]}>
              <CustomDropdown title="Export" />
            </div>
          </div>
          <div className="text-center">
            <div className={styles["button"]}>
              <CustomDropdown title="View History" />
            </div>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <FilterInTable componentName="Advertisement Management" />
      </div>

      <DataTable
        data={currentItems}
        columns={columns}
        customStyles={customStyles}
      />

      <PaginationComponent
        totalItems={data.length}
        siblingCount={2}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </section>
  );
};

export default Active;